import {RateAlertInfoReal} from "../interface/RateAlertInfo";
import {RateAlertStatusEnum} from "../enums/RateAlertTabEnum";

export function countPendingAlerts(array:RateAlertInfoReal[]) {
    return array.reduce((count, item) => {
        return count + (item.alertStatus === RateAlertStatusEnum.PENDING ? 1 : 0);
    }, 0);
}

